// extracted by mini-css-extract-plugin
export default {"header":"AboutHeader_header__K4t4p","circle":"AboutHeader_circle__Q7xi0","introduction":"AboutHeader_introduction__tO4es"};